import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const hostingApi = createApi({
  reducerPath: "hostingApis",
  baseQuery,
  tagTypes: ["hosting"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getHostingPackages: builder.query({
      query: () => "hosting/packages",
      providesTags: ["hosting"],
    }),
    webHostingRegister: builder.mutation({
      query: (body) => ({
        url: "hosting/cpanel/register",
        method: "POST",
        body,
      }),
      invalidatesTags: ["hosting"],
    }),
  }),
});

export const { useGetHostingPackagesQuery, useWebHostingRegisterMutation } =
  hostingApi;
